import { render } from "./setTutorial.vue?vue&type=template&id=759aa97a&scoped=true"
import script from "./setTutorial.vue?vue&type=script&lang=js"
export * from "./setTutorial.vue?vue&type=script&lang=js"

import "./setTutorial.vue?vue&type=style&index=0&id=759aa97a&scoped=true&lang=scss"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-759aa97a"]])

export default __exports__